import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ModuleFlowService } from '../services/module-flow.service';

export const popupPassedGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const flow = inject(ModuleFlowService);

  if (flow.hasPassedPopup()) {
    return true;
  }

  const courseId = route.paramMap.get('courseId') ?? '1';

  // Refreshing on a module-view page bounces back to the module list
  // (and sets the flag so the list's guard passes through).
  if (route.paramMap.has('moduleId')) {
    flow.passPopup();
    return router.createUrlTree([`/course-modules/${courseId}/list`]);
  }

  // Refreshing on the module list (no moduleId) bounces back to the course detail page.
  return router.createUrlTree([`/course-modules/${courseId}`]);
};
